// MBQ OCT 2025 RESTYLING: USER'S UX PREFERENCE
const UX_TYPE = {
  OLD_APP: 'V0', // Premium without restyling
  NEW_APP: 'V1' // Premium restyling  
}

export default UX_TYPE